<template>
    <svg class="block fill-current flex-none" viewBox="0 0 14 20"><path d="m1 20c.212 0 .424-.067.6-.2l12-9c.252-.189.4-.486.4-.8s-.148-.611-.4-.8l-12-9c-.303-.228-.709-.263-1.047-.095-.339.17-.553.516-.553.895v18c0 .379.214.725.553.895.141.07.295.105.447.105"/></svg>
</template>
